import { LitElement, html, css } from 'lit';
import { BootstrapCSS } from '../../resources/css/bootstrap.css';
import { EplibStyles } from '../../resources/css/style.css.js';

export class EplibBrowseView extends LitElement {

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('eplib-browse-count-updated', event => this._setHitCount(event));
    window.addEventListener('eplib-open-search', event => this._setSearch(event));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('eplib-browse-count-updated', event => this._setHitCount(event));
    window.removeEventListener('eplib-open-search', event => this._setSearch(event));
  }


  async firstUpdated() {
    super.firstUpdated();
    document.title = 'EarlyPrint Library Browse Works';
    document.querySelector("meta[name='description']").setAttribute('content', 'Page through and search list of filtered texts');
  }

  _setHitCount(event) {
    const hitCountSpan = this.shadowRoot.querySelector('#hit-count');
    if (hitCountSpan) {
      hitCountSpan.innerText = event.detail.count.toLocaleString();
    }
  }

  _setSearch(event) {
    this.shadowRoot.querySelector('#search_item').setAttribute('open', true);
    this.shadowRoot.querySelector('#result_pattern').innerHTML = ` for ${event.detail.pattern}`;
  }

  static get styles() {
    return [
      BootstrapCSS,
      EplibStyles
    ];
  }

  render() {
    return html`
    <div class="container-fluid">
      <div class="row actions">
        <div class="col-lg-12">
          <p/>
        </div>
      </div>
      <div class="row list-browse">
        <div class="col-md-3">
          <eplib-text-filter-form channel="browse"></eplib-text-filter-form>
        </div>
        <div class="col-md-6">
          <div class="container-fluid">
            <div id="browse_search_accordion">
              <details open id="browse_item" name="browse_search_accordion">
                <summary id="heading_browse">
                  <h6 class="pull-left" style="margin-left: 25px">Browsing
                    <span class="result-count">
                      <span id="hit-count">...</span>
                    </span>
                    documents.
                  </h6>
                </summary>
                <div class="col-md-12 list-works well well-sm">
                  <eplib-browse-works per-page="20"></eplib-browse-works>
                </div>
              </details>
              <details id="search_item" name="browse_search_accordion">
                <summary id="heading_search">
                  <h6 class="pull-left" style="margin-left: 25px">Search Results<span id="result_pattern"/></h6>
                </summary>
                <div class="col-md-12 list-works well well-sm">
                  <eplib-page class="{loaded}">
                    <eplib-blacklab-results id="kwic" target="../works" per-page="{perPage}" pattern="{pattern}" sort="{sort}" filter="{filter}" path="data">
                    </eplib-blacklab-results>
                  </eplib-page>
                </div>
              </details>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <eplib-blacklab-search-form></eplib-blacklab-search-form>
        </div>
      </div>
    </div>
  `;
  }
}

customElements.define('eplib-browse-view', EplibBrowseView);
